import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import { Button } from '@material-ui/core';
import { SearchInput } from 'components';
import { useHistory } from 'react-router-dom';
import { NearMeOutlined } from '@material-ui/icons';

const useStyles = makeStyles(theme => ({
  root: {},
  row: {
    height: '42px',
    display: 'flex',
    alignItems: 'center',
    marginTop: theme.spacing(1)
  },
  spacer: {
    flexGrow: 1
  },
  addSchemaButton: {
    marginRight: theme.spacing(1)
  },
  searchInput: {
    marginRight: theme.spacing(1)
  }
}));

const SchemaToolbar = props => {
  const {
    className,
    onSearch,
    value,
    onAddSchema,
    onArchiveChange,
    showActive,
    ...rest
  } = props;
  const classes = useStyles();
  const history = useHistory();

  const onClickAddSchema = () => {
    onAddSchema();
    history.push(`/schema/details`);
  };

  const onSearchChange = event => {
    if (onSearch && typeof onSearch === 'function') {
      onSearch(event.target.value);
    }
  };

  return (
    <div {...rest} className={clsx(classes.root, className)}>
      <div className={classes.row}>
        <SearchInput
          className={classes.searchInput}
          placeholder="Search Schemas"
          value={value}
          onChange={onSearchChange}
        />
        <span className={classes.spacer} />
        <Button
          className={classes.addSchemaButton}
          color="primary"
          variant="contained"
          startIcon={<NearMeOutlined fontSize="default" />}
          onClick={() => history.push('/enriched-schema')}>
          Enriched Schema configuration
        </Button>
        <Button
          color="primary"
          variant="contained"
          className={classes.addSchemaButton}
          value="add"
          onClick={onArchiveChange}>
          {showActive ? 'View Archived Schemas' : 'View Active Schemas'}
        </Button>
        <Button
          color="primary"
          variant="contained"
          className={classes.addSchemaButton}
          value="add"
          onClick={onClickAddSchema}>
          Add Schema
        </Button>
      </div>
    </div>
  );
};

export default SchemaToolbar;
